import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionPage.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { getServiceDetailsApi, loginApi, printLogsApi, subscriptionRedirectApi } from '../Http/http';
import { FaCheck } from "react-icons/fa6"

const SubscriptionPage = () => {
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(true);
    const [subscribeLoading, setSubscribeLoading] = useState(false);
    const [pack, setPack] = useState(null);
    const [packs, setPacks] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const fetchServiceDetails = async () => {
        try {
            setLoading(true);
            const response = await getServiceDetailsApi();
            setPacks(response?.data?.data);
            setPack(response?.data?.data?.[0]?.newServiceId);
            setLoading(false);
            setError(false);
        } catch (error) {
            setLoading(false);
            setError(true);
            toast.error(error?.response?.data?.message || error?.message || error?.data?.message);
            console.log(error, 'error');
        }
    }

    const saveLogs = async (data) => {
        try {
            const response2 = await printLogsApi(data);
            console.log(response2, 'response2...');
        } catch (error) {
            console.log(error, 'error---');
        }
    }

    const handleSubscription = async () => {
        try {
            if (msisdn?.trim().length > 0) {

                setSubscribeLoading(true);

                let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

                if (msisdnWithCountryCode.startsWith('0')) {
                    msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
                }

                if (!msisdnWithCountryCode.startsWith('880')) {
                    msisdnWithCountryCode = '880' + msisdnWithCountryCode;
                }

                loginApi({
                    msisdn: msisdnWithCountryCode,
                }).then(() => {
                    setSubscribeLoading(false);
                    toast.success("You are already Subscribed! Logging In...");
                    setTimeout(() => {
                        window.location.href = `https://bd-d2g.rashigames.com/success?msisdn=${msisdnWithCountryCode}&type=login`;
                    }, 500);
                }).catch(async (err) => {
                    if (err?.response?.status === 400) {
                        let data = {
                            msisdn: msisdnWithCountryCode,
                            serviceId: pack,
                            channel: "Others",
                            paymentSuccessRedirectUrl: `https://bd-d2g.rashigames.com/success?msisdn=${msisdnWithCountryCode}`,
                            paymentFailedRedirectUrl: "https://subscribe-d2g.rashigames.com/failed",
                            paymentDenyRedirectUrl: "https://subscribe-d2g.rashigames.com/denied",
                            transactionId: "Trx-" + extRef
                        };

                        const response = await subscriptionRedirectApi(data);
                        setSubscribeLoading(false);

                        let redirect_url = response?.data?.data?.paymentUrl;
                        if (redirect_url) {
                            window.location.href = redirect_url
                        }
                        else {
                            toast.error('Redirect url not found!');
                        }
                    } else if (err?.response?.status === 500) {
                        toast.error("Something went wrong on the server. Please try again later.");
                    } else {
                        toast.error("Something went wrong! Please try again.");
                    }
                });
            }
            else {
                toast.error("Please Enter the Number!");
                return;
            }

        } catch (error) {
            console.log(error, 'error---');
            setSubscribeLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || "Something Went Wrong!");
        }
    }

    useEffect(() => {
        fetchServiceDetails();
        // saveLogs({data:"hello"});
    }, []);
    return (
        <main className={classes.main}>
            <div className={classes.container}>
                <h1 className={classes.portalDescription}>Door 2 Games</h1>

                <div className={classes.landingPageBanner}>
                    <img src="/assets/banner.gif" alt="Banner" className={classes.banner} />
                </div>

                {loading ? <h1 style={{ textAlign: "center", width: "100%" }}>Loading...</h1> :
                    error ?
                        <p className={classes.packs_heading} style={{ background: "red" }}>Some Error Occured! Please Reload the Page!</p>
                        :
                        <>

                            <div className={classes.actions_box_container}>
                                <div className={classes.actions_box}>
                                    <button type="button" className={classes.action_box}
                                        onClick={() => navigate("/login")}
                                    >
                                        Login
                                    </button>
                                    <button type="button" className={`${classes.action_box} ${classes.active}`}
                                        onClick={() => navigate("/")}
                                    >
                                        Subscribe
                                    </button>
                                </div>
                            </div>

                            <input type='number' placeholder='Enter your Number' value={msisdn} onChange={(e) => setMsisdn(e.target.value)}
                                className={classes.input}
                            />

                            <div className={classes.packs}>
                                <p className={classes.packs_heading}>Choose a Pack</p>

                                {packs.length > 0 && packs?.map((item, index) => {
                                    if (index == 0) {
                                        return (
                                            <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                                                onClick={() => setPack(item?.newServiceId)}
                                                key={index}
                                            >
                                                <span className={`${classes.pack_header} ${classes.shade_blue}`}>{
                                                    item?.durationInDay == 1 ? "Daily" : item?.durationInDay == 7 ? "Weekly" : "Monthly"
                                                } subscription price point</span>
                                                {
                                                    pack == item?.newServiceId ?
                                                        <div className={`${classes.checked_radio} ${pack == item?.newServiceId && classes.shade_blue}`}>
                                                            <FaCheck className={classes.checked_icon} />
                                                        </div>
                                                        : <div className={classes.dummy_radio}>

                                                        </div>
                                                }
                                                <p className={`${classes.pack_price_point} ${classes.active}`}>
                                                    {item?.price} Tk/{" "}
                                                    {item?.durationInDay == 1 ? "Day" : item?.durationInDay == 7 ? "Week" : "Month"}
                                                </p>
                                            </button>
                                        )
                                    }

                                })}
                            </div>

                            <button className={classes.subscribeBtn} id="subscribe_btn" onClick={handleSubscription}
                                disabled={subscribeLoading}
                            >
                                {subscribeLoading ? "Subscribing..." : (
                                    <>
                                        GET IT NOW <img src="assets/lock.png" alt="lock" className={classes.lockImg} />
                                    </>

                                )}
                            </button>

                            <div className={classes.termsSection}>
                                <h1 className={classes.termsHeading}>Terms & Conditions</h1>
                                <ul className={classes.termsList}>
                                    {/* <li>The service has 3 packs (Daily, Weekly and Monthly).</li> */}
                                    <li>The service has 1 Daily Pack.</li>
                                    <li>Your Subscription will be renewed based on your subscription pack, automatically until you unsubscribe.</li>
                                    <li>You can unsubscribe from the service anytime, by deactivating from the portal.</li>
                                    <li>All data-enabled features & Smartphone users can enjoy full service.</li>
                                    <li>Customer can access the content at any time during the subscription validity period.</li>
                                </ul>
                            </div>
                            {/* <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                            <button className={classes.loginLink} onClick={() => navigate(`/login?ext_id=${extRef}`)}>
                                Already a Subscriber, Login
                            </button>
                        </div> */}
                        </>
                }
            </div>


        </main >
    )
}

export default SubscriptionPage